import styled from 'styled-components';

export const StyledDeletedLocations = styled.div`
    padding: 2rem;
`;
